import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
`;

export const Env = styled.div`
  width: 80px;
  height: 80px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  box-shadow: inset 0 0 10px 0 rgba(0, 0, 0, 0.5);
  border-radius: 10px;
  cursor: pointer;
  position: relative;
  opacity: 0.8;

  &:hover {
    opacity: 1;

    .title {
      opacity: 1;
    }
  }
`;

export const Title = styled.div`
  position: absolute;
  font-size: 11px;
  color: #fff;
  padding: 5px;
  bottom: -23px;
  opacity: 0.5;
`;
